import { Routes } from '@angular/router'

import { ClinicExistsGuard } from '../core/guards/clinic.guard'
import { ClinicModulesGuard } from '../core/guards/clinic-modules.guard'

export const PublicsRoutes: Routes = [
  {
    path: '',
    canActivate: [
      ClinicExistsGuard,
    ],
    children: [
      {
        path: 'ie',
        loadChildren: () => import('./ie/ie.module').then(m => m.IeModule),
      },
      {
        path: 'login',
        loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
      },
      {
        path: 'code',
        loadChildren: () => import('./login-with-code/login-with-code.module').then(m => m.LoginWithCodeModule),
      },
      {
        path: 'logout',
        loadChildren: () => import('./logout/logout.module').then(m => m.LogoutModule),
      },
      {
        path: 'link',
        loadChildren: () => import('./magic-link/magic-link.module').then(m => m.MagicLinkModule),
      },
      {
        path: 'appointment-schedule',
        canActivate: [ClinicModulesGuard],
        data: {
          modules: ['appointmentRequests'],
        },
        loadChildren: () => import('../public/appointment-schedule/appointment-schedule.module')
          .then(m => m.AppointmentScheduleModule),
      },
      {
        path: 'subscription',
        loadChildren: () => import('./subscription/subscription.module').then(m => m.SubscriptionModule),
      },
      {
        path: 'setup',
        loadChildren: () => import('./setup/setup.module').then(m => m.SetupModule),
      },
      {
        path: 'patient/incoming/:id',
        redirectTo: '/link/appointments/:id',
      },
      {
        path: 'incoming/:id',
        redirectTo: '/link/appointments/:id',
      },
      {
        path: '**',
        loadChildren: () => import('./notfound/notfound.module').then(m => m.NotFoundModule),
      },
    ],
  },
]
